"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCheckoutStorage = exports.getCustomerDeleteStorage = exports.getCustomerWelcomeFlyoutVisibilityStorage = exports.getCustomerEmailStorage = exports.getSearchHistoryStorage = exports.getRedemptionEntryHideInfoBannerFlagStorage = exports.getLastTouchpointValueStorage = exports.getLastSeenProductIdsStorage = exports.getWishlistStorage = exports.getPersonalInfoStorage = exports.getPaypalOrderIdStorage = exports.getEvelinOrderIdStorage = void 0;
var cookie_storage_item_1 = require("./services/cookie-storage-item");
var json_storage_item_1 = require("./services/json-storage-item");
var browser_storage_item_1 = require("./services/browser-storage-item");
var last_seen_products_1 = require("./services/last-seen-products");
var wishlist_storage_1 = require("./services/wishlist-storage");
var getEvelinOrderIdStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.evelinOrderId', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getEvelinOrderIdStorage = getEvelinOrderIdStorage;
var getPaypalOrderIdStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.paypalOrderId', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getPaypalOrderIdStorage = getPaypalOrderIdStorage;
var getPersonalInfoStorage = function () {
    var twoHoursInSeconds = 120 * 60;
    return new json_storage_item_1.JsonStorageItem(new cookie_storage_item_1.CookieStorageItem('evelin.personalInformation', twoHoursInSeconds));
};
exports.getPersonalInfoStorage = getPersonalInfoStorage;
var getWishlistStorage = function () {
    return new wishlist_storage_1.WishlistStorage();
};
exports.getWishlistStorage = getWishlistStorage;
var getLastSeenProductIdsStorage = function () {
    return new last_seen_products_1.LastSeenProductIdsStorage();
};
exports.getLastSeenProductIdsStorage = getLastSeenProductIdsStorage;
var getLastTouchpointValueStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.lastTouchpointValue', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getLastTouchpointValueStorage = getLastTouchpointValueStorage;
var getRedemptionEntryHideInfoBannerFlagStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.redemptionEntry.hideInfoBanner', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getRedemptionEntryHideInfoBannerFlagStorage = getRedemptionEntryHideInfoBannerFlagStorage;
var getSearchHistoryStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.search.history', browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getSearchHistoryStorage = getSearchHistoryStorage;
var getCustomerEmailStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.customer.email', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getCustomerEmailStorage = getCustomerEmailStorage;
var getCustomerWelcomeFlyoutVisibilityStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.customer.welcomeFlyoutEnabled', browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getCustomerWelcomeFlyoutVisibilityStorage = getCustomerWelcomeFlyoutVisibilityStorage;
var getCustomerDeleteStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.customer.deleteNotificationEnabled', browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getCustomerDeleteStorage = getCustomerDeleteStorage;
function clearCheckoutStorage() {
    (0, exports.getEvelinOrderIdStorage)().remove();
    (0, exports.getPaypalOrderIdStorage)().remove();
    (0, exports.getPersonalInfoStorage)().remove();
}
exports.clearCheckoutStorage = clearCheckoutStorage;
//# sourceMappingURL=index.js.map